module.exports = __webpack_public_path__ + "img/crown_bg_red.eb92a5fa.png";